import styled from 'styled-components';

const SegmentName = styled.p`
  padding-top: 16px;
  font-weight: bold;
  color: black;
  margin: 0;
`;

const SubheaderContainer = styled.div`
  display: flex;
`;

const SegmentParticipants = styled.p`
  color: black;
  font-size: 12px;
`;

export {

  SegmentName,
  SubheaderContainer,
  SegmentParticipants,
};
